import { apiClient, type CustomerExEntity } from '@/libs/api'

export type FetchCustomerQuery = {
  tenantKey: string
  customerId: number
}

export const fetchCustomer = async (
  { tenantKey, customerId }: FetchCustomerQuery,
  signal?: AbortSignal
): Promise<CustomerExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .customers._id(customerId)
    .$get({
      config: { signal }
    })
  return data
}
